// Copyright 2018 Sorama B.V.

import { GenericMeasurement, MeasurementPartType, Point3D } from "datatypes/SoramaWebApi";
import { IModal } from "libraries/WorkflowFramework/Interfaces/IModal";
import { IWorkflowModuleModalInstance } from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";

export class BeamformProbeModal implements IModal<BeamformProbeModalState, BeamformProbeModalReturnState> {
    private newProbeMode: boolean;
    private isScanningMeasurement: boolean;
    private state: BeamformProbeModalState;
    private returnState: BeamformProbeModalReturnState;
    private modalInstance: IWorkflowModuleModalInstance<BeamformProbeModalState, BeamformProbeModalReturnState>;

    private get probePosition(): Point3D {
        if (!this.state) return { x: 0, y: 0, z: 0 };

        return this.newProbeMode ? this.state.targetPoint : this.state.probeMeasurement.parts[0].position;
    }

    public activateModal(
        state: BeamformProbeModalState,
        modalInstance: IWorkflowModuleModalInstance<BeamformProbeModalState, BeamformProbeModalReturnState>
    ): void {
        this.isScanningMeasurement =
            state.measurement.parts.filter((x) => x.measurementType === MeasurementPartType.Audio).length > 1;

        this.modalInstance = modalInstance;
        this.state = state;
        this.returnState = <BeamformProbeModalReturnState>state;
        this.newProbeMode = !!this.state.targetPoint;
    }

    public close(): BeamformProbeModalReturnState {
        return this.returnState;
    }

    private closeAndNavigate(): void {
        this.returnState.navigateToOverview = true;
        this.modalInstance.close();
    }

    private delete(): void {
        this.returnState.delete = true;
        this.modalInstance.close();
    }
}

// View-Model for modal needs to be first class in the file
export class BeamformProbeModalState {
    public measurement: GenericMeasurement;
    public targetPoint?: Point3D;
    public probeMeasurement?: GenericMeasurement;
}

export class BeamformProbeModalReturnState extends BeamformProbeModalState {
    public name: string;
    public delete: boolean;
    public navigateToOverview: boolean;
}
